import React from 'react';
import { SellerWarehouseTemplate } from 'themes/modules/seller/pages';
import { SellerWarehouseViewStore } from '../stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(
	(rootStore, componentProps) => new SellerWarehouseViewStore(rootStore, componentProps),
	'sellerWarehouseViewStore'
)
class SellerWarehouse extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <SellerWarehouseTemplate {...this.props} viewStore={this.props.sellerWarehouseViewStore} />;
	}
}

export default SellerWarehouse;
